/* ==========================================================
   MEGA NAV — controller (vanilla JS, no deps)
   ========================================================== */
(function () {
  'use strict';

  function init() {
    var nav = document.querySelector('[data-mega-nav]');
    var shell = document.querySelector('[data-mn-shell]');
    if (!nav || !shell) return;

    /* ------- shell height drives body offset ------- */
    var announce = shell.querySelector('.mn-announce');
    function syncShellHeight() {
      var h = shell.offsetHeight || 0;
      document.documentElement.style.setProperty('--mn-shell-h', h + 'px');
    }
    syncShellHeight();
    window.addEventListener('resize', syncShellHeight);
    if (announce) {
      var x = announce.querySelector('.mn-announce__x');
      if (x) x.addEventListener('click', function () {
        announce.hidden = true;
        syncShellHeight();
      });
    }

    /* ------- scroll states: transparent / hidden / solid ------- */
    var lastY = window.scrollY;
    var ticking = false;
    var TOP_BAND = 50;
    var drawerOpen = false;
    // Pages other than the homepage opt out of the transparent state via
    // data-force-solid. The bar still hides on scroll-down, but never goes
    // transparent — it stays solid white (or its scrolled appearance).
    var forceSolid = nav.getAttribute('data-force-solid') === 'true';
    function setState(state) {
      ['is-transparent', 'is-hidden', 'is-solid'].forEach(function (s) {
        nav.classList.remove(s);
        shell.classList.remove(s);
      });
      nav.classList.add(state);
      shell.classList.add(state);
    }
    function updateState() {
      var y = window.scrollY;
      var panelOpen = nav.classList.contains('is-open');
      // Drawer or panel open → force solid white nav. Never hide when drawer is open.
      if (drawerOpen || panelOpen) {
        setState('is-solid');
      } else if (!forceSolid && y < TOP_BAND) {
        setState('is-transparent');
      } else if (y > lastY && y > TOP_BAND + 20) {
        setState('is-hidden');
      } else {
        setState('is-solid');
      }
      lastY = y;
      ticking = false;
    }
    updateState();
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateState); ticking = true; }
    }, { passive: true });

    /* ------- desktop hover dropdowns ------- */
    var labels = nav.querySelectorAll('[data-mega-trigger]');
    var panels = nav.querySelectorAll('[data-panel]');
    var closeTimer = null;
    var activeIdx = null;

    function openPanel(idx) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (idx === activeIdx) return;
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === String(idx));
      });
      labels.forEach(function (l) {
        var match = l.getAttribute('data-mega-trigger') === String(idx);
        l.classList.toggle('is-active', match);
        l.setAttribute('aria-expanded', match ? 'true' : 'false');
      });
      nav.classList.add('is-open');
      activeIdx = idx;
      // Recompute scroll state so .is-solid takes over visually
      updateState();
    }

    function closePanels() {
      nav.classList.remove('is-open');
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      labels.forEach(function (l) {
        l.classList.remove('is-active');
        l.setAttribute('aria-expanded', 'false');
      });
      activeIdx = null;
      updateState();
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanels, 120);
    }
    function cancelClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }

    labels.forEach(function (label) {
      var idx = label.getAttribute('data-mega-trigger');
      if (!nav.querySelector('[data-panel="' + idx + '"]')) return; // no panel → no-op
      label.addEventListener('mouseenter', function () { openPanel(idx); });
      label.addEventListener('focus', function () { openPanel(idx); });
      label.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          if (label.tagName === 'BUTTON') {
            e.preventDefault();
            if (activeIdx === idx) closePanels(); else openPanel(idx);
          }
        }
        if (e.key === 'Escape') closePanels();
      });
    });

    nav.addEventListener('mouseleave', scheduleClose);
    nav.addEventListener('mouseenter', cancelClose);
    panels.forEach(function (p) {
      p.addEventListener('mouseenter', cancelClose);
      p.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanels();
    });

    /* ------- mobile drawer ------- */
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) {
      var toggleBtns = document.querySelectorAll('[data-drawer-open]');
      var closeBtns  = drawer.querySelectorAll('[data-drawer-close]');
      var subOpenBtns  = drawer.querySelectorAll('[data-open-sub]');
      var subBackBtns  = drawer.querySelectorAll('[data-drawer-back]');
      var burger = nav.querySelector('.mega-nav__hamburger');

      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        // Lock page scroll. Setting it on BOTH <html> and <body> covers
        // mobile, where the document element is often the scroll container
        // (body overflow alone doesn't stop the page scrolling there).
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        // Flag on <body> so page-level sticky bars (product add-to-cart) can
        // hide themselves while the menu is open. The drawer lives in the
        // header's own stacking context, so a higher z-index alone can't beat
        // a fixed bar elsewhere on the page — hiding it is the reliable fix.
        document.body.classList.add('mn-drawer-open');
        if (burger) {
          burger.classList.add('is-active');
          burger.setAttribute('aria-expanded', 'true');
        }
        drawerOpen = true;
        updateState();
      }
      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.classList.remove('mn-drawer-open');
        drawer.querySelectorAll('[data-sub]').forEach(function (s) {
          s.classList.remove('is-active');
        });
        if (burger) {
          burger.classList.remove('is-active');
          burger.setAttribute('aria-expanded', 'false');
        }
        drawerOpen = false;
        updateState();
      }
      function toggleDrawer() {
        if (drawer.classList.contains('is-open')) closeDrawer();
        else openDrawer();
      }

      toggleBtns.forEach(function (b) { b.addEventListener('click', toggleDrawer); });
      closeBtns.forEach(function (b) { b.addEventListener('click', closeDrawer); });
      subOpenBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.getAttribute('data-open-sub');
          var sub = drawer.querySelector('[data-sub="' + key + '"]');
          if (sub) sub.classList.add('is-active');
        });
      });
      subBackBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          var pane = b.closest('[data-sub]');
          if (pane) pane.classList.remove('is-active');
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });

      /* If the viewport grows past the mobile breakpoint while the
         drawer is open (resize, rotate, or window expand), force-close
         it so the desktop nav isn't covered by a stale full-screen pane. */
      var mqDesktop = window.matchMedia('(min-width: 990px)');
      function handleBreakpointChange(e) {
        if (e.matches && drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      }
      if (typeof mqDesktop.addEventListener === 'function') {
        mqDesktop.addEventListener('change', handleBreakpointChange);
      } else if (typeof mqDesktop.addListener === 'function') {
        // Safari < 14 fallback
        mqDesktop.addListener(handleBreakpointChange);
      }
    }

    /* ------- cart icon → drawer (preserve theme cart-drawer) ------- */
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') {
          e.preventDefault();
          cd.open(link);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---------- Favorites header badge sync ----------
     The heart link in .mega-nav__actions has a hidden <span> with
     [data-favorites-count]. We populate it from localStorage on load
     and any time the 'scent:favorites:change' event fires (dispatched
     by assets/scent-card.js whenever a heart is toggled). The badge
     hides itself entirely when the count is 0, mirroring the cart
     bubble's "show only when non-empty" behavior.

     Lives in mega-nav.js so it loads on every page that has the
     header — including pages that don't include scent-card.js (e.g.
     the favorites page itself before any cards are mounted), so the
     count is always trustworthy. */
  function readFavCount() {
    try {
      var raw = window.localStorage.getItem('scent_favorites');
      if (!raw) return 0;
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr.length : 0;
    } catch (_e) { return 0; }
  }
  function syncFavBadge() {
    var badge = document.querySelector('[data-favorites-count]');
    var link = document.querySelector('[data-favorites-link]');
    if (!badge && !link) return;
    var n = readFavCount();
    if (badge) {
      if (n > 0) {
        badge.textContent = String(n);
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    }
    if (link) link.classList.toggle('is-active', n > 0);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFavBadge);
  } else {
    syncFavBadge();
  }
  document.addEventListener('scent:favorites:change', syncFavBadge);
  window.addEventListener('storage', function (e) {
    if (e.key === 'scent_favorites') syncFavBadge();
  });
})();
